"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveSelector = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const components_1 = require("./components");
const InteractiveSelectorContext = (0, react_1.createContext)({ selectable: true });
function Option(_a) {
    var { value, editable, setEditable, selectable, onSubmit, children } = _a, props = __rest(_a, ["value", "editable", "setEditable", "selectable", "onSubmit", "children"]);
    const { onSelect, selectable: globalSelectable } = (0, react_1.useContext)(InteractiveSelectorContext);
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (editable && inputRef.current) {
            inputRef.current.focus();
        }
    }, [editable]);
    const handleSubmit = (inputValue) => {
        setEditable === null || setEditable === void 0 ? void 0 : setEditable(false);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(inputValue);
    };
    const inputStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
      ${!editable && components_1.innerInputDisabled}
    `, [editable]);
    const localSelectable = selectable !== null && selectable !== void 0 ? selectable : globalSelectable;
    return ((0, jsx_runtime_1.jsxs)(components_1.StyledSelectorOptionWrap, Object.assign({ "$selectable": localSelectable, onClick: () => localSelectable && value && (onSelect === null || onSelect === void 0 ? void 0 : onSelect(value.id)) }, { children: [(0, jsx_runtime_1.jsx)(components_1.StyledInnerInput, Object.assign({ css: inputStyle, ref: inputRef, name: "title", defaultValue: value === null || value === void 0 ? void 0 : value.value, disabled: !editable, onSubmit: handleSubmit, optional: true }, props)), children] })));
}
function Addon({ children, className, data }) {
    return ((0, jsx_runtime_1.jsx)(components_1.StyledAddonWrap, Object.assign({ "$empty": (data === null || data === void 0 ? void 0 : data.length) === 0, className: className }, { children: children })));
}
function InteractiveSelector({ children, dataLoading, local, selectable = true, render: Render, onSearch, onSubmit, searchThreshold = 1, onSelect, placeholder, icon: Icon, suffix, dropdownProps, inputValue, forceError, disabled, className, }) {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const search = (0, react_1.useCallback)((v) => onSearch === null || onSearch === void 0 ? void 0 : onSearch(v), [onSearch]);
    const debouncedSearch = (0, app_1.useDebounce)(search, local ? 0 : 300);
    (0, react_1.useEffect)(() => {
        setLoading(Boolean(dataLoading));
    }, [dataLoading]);
    const handleChange = (0, react_1.useCallback)((value) => {
        if (local) {
            debouncedSearch(value);
        }
        else if (value.length >= searchThreshold) {
            setLoading(true);
            debouncedSearch(value);
        }
        return value;
    }, [local, searchThreshold, debouncedSearch]);
    const content = (0, react_1.useCallback)(() => ((0, jsx_runtime_1.jsx)(components_1.StyledDropdownWrap, { children: (0, jsx_runtime_1.jsx)(Render, {}) })), [Render]);
    const loader = (0, react_1.useCallback)(() => (0, jsx_runtime_1.jsx)(components_1.StyledLoading, {}), []);
    const contextValue = (0, react_1.useMemo)(() => ({ onSelect, selectable }), [onSelect, selectable]);
    return ((0, jsx_runtime_1.jsx)(InteractiveSelectorContext.Provider, Object.assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(components_1.StyledDropdown, Object.assign({ adherent: true, render: loading ? loader : content }, dropdownProps, { children: ({ open, layerSide }) => ((0, jsx_runtime_1.jsx)(components_1.StyledContentWrap, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(components_1.StyledMainInput, Object.assign({ "$layerSide": layerSide, "$open": open || undefined, prefix: Icon ? ((0, jsx_runtime_1.jsx)(components_1.StyledIconWrap, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })) : undefined, suffix: suffix, name: "main", placeholder: placeholder, onChange: handleChange, optional: true, standalone: true, onSubmit: onSubmit, defaultValue: inputValue, disabled: disabled, forceError: forceError }, { children: children })) }))) })) })));
}
exports.InteractiveSelector = InteractiveSelector;
InteractiveSelector.Option = Option;
InteractiveSelector.Addon = Addon;
